exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.theme--light.v-expansion-panel .v-expansion-panel__container[data-v-0b67144a] {\n  background-color: #27488e !important;\n  color: white;\n}\n.v-expansion-panel__container.custom-panels\n  > .v-expansion-panel__header\n  > .v-expansion-panel__header__icon\n  > i[aria-hidden='true'][data-v-0b67144a] {\n  color: white !important;\n}\n", ""]);

// exports
